import { 
  LOAD_ELEVATION_DATA_IN_PROGRESS,
  LOAD_ELEVATION_DATA_SUCCESS,
  LOAD_ELEVATION_DATA_FAILURE,
  LOAD_CHANGE_ROLE_DATA_SUCCESS,
  LOAD_CHANGE_PERMISSION_DATA_SUCCESS,
  LOAD_USER_PERMISSION_DATA_SUCCESS,
  ELEVATION_OPERATION_COMPLETED,
} from "./actions";

const initialState = { isLoading: false, currentUserData:[],roleChangeRequestData:[],permissionChangeRequestData:[],userPermissionsList:[]};

export const elevationData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_ELEVATION_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        currentUserData: data,
      };
    }
    case LOAD_ELEVATION_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_ELEVATION_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case LOAD_CHANGE_ROLE_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        roleChangeRequestData: data,
      };
    };
    case LOAD_CHANGE_PERMISSION_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        permissionChangeRequestData: data,
      };
    };
    case LOAD_USER_PERMISSION_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        userPermissionsList: data,
      };
    }
    case ELEVATION_OPERATION_COMPLETED:
      return {
          ...state,
          isLoading: false,
      }; 
    default:
      return state;
  }
};
